<template>
  <ViewComment />
</template>

<script>
import ViewComment from '../../components/comment/ViewComment.vue'
export default {
  components: {
    ViewComment,
  },
}
</script>
